/**
 * PHSIMS Web Admin - Main Entry Point
 * Author: Iswe Solutions Team
 * 
 * Renders application immediately, auth initialization happens in background.
 * This provides faster perceived load times.
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initializeAuth } from './authProvider';

// Hide the initial loading screen
const hideLoadingScreen = () => {
  const loader = document.getElementById('app-loading');
  if (loader) {
    loader.classList.add('fade-out');
    setTimeout(() => {
      loader.style.display = 'none';
    }, 300);
  }
};

// Render the app immediately - don't wait for auth check
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize auth in background (for SSO setup if enabled)
initializeAuth().catch(error => {
  console.log('Auth initialization (background):', error);
});

// Hide loading screen after React renders
requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    hideLoadingScreen();
  });
});
